import { render, staticRenderFns } from "./moneyInList.vue?vue&type=template&id=452d546b&scoped=true"
import script from "./moneyInList.vue?vue&type=script&lang=js"
export * from "./moneyInList.vue?vue&type=script&lang=js"
import style0 from "./moneyInList.vue?vue&type=style&index=0&id=452d546b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452d546b",
  null
  
)

export default component.exports